import { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { initAxiosPerfTracking, isPerfDiagnosticsEnabled } from '../utils/pagePerf';

/**
 * Oturum açıkken axios süre ölçümü (opt-in).
 */
export default function PerfDiagnosticsBootstrap() {
  const { user } = useAuth();

  useEffect(() => {
    if (!user || !isPerfDiagnosticsEnabled()) return undefined;
    return initAxiosPerfTracking();
  }, [user]);

  return null;
}
